export default [
  {
    path: '/ticket-finder/search',
    component: () => import('./Search.vue'),
    name: 'ticketFinderSearch'
  },
  {
    path: '/ticket-finder/index-info',
    component: () => import('./IndexInfo.vue'),
    name: 'ticketFinderIndexInfo'
  }
]
